

<div class="grid">


<div class="col-3" (keyup.enter)="onSubmitClick()">

    <p-card header="Login into Walletron Portal" subheader="" styleClass="ui-card-light">

        <div class="d-flex align-items-end">
            <mat-icon class="nav-caption">lock</mat-icon>
        </div>

        <div>
            <div class="field grid">
                <label for="userName" class="col-fixed label" style="width:150px">Username:</label>
                <div class="col">
                    <!-- <input pInputText id="userName" type="text" [(ngModel)]="login.userName" class="text-base text-color surface-overlay p-1 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"> -->
                    <input pInputText id="userName" type="text" [(ngModel)]="login.userName">
                </div>
            </div>      

            <div class="field grid">
                <label for="password" class="col-fixed label" style="width:150px">Password:</label>
                <div class="col">
                    <!-- <input pPassword id="password" type="password" [feedback]="false"  [(ngModel)]="login.password" class="text-base text-color surface-overlay p-1 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"> -->
                    <input pPassword id="password" type="password" [feedback]="false"  [(ngModel)]="login.password">
                </div>
            </div>      
            
            @if(isPasswordChangeRequired) {
                <div class="field grid">
                    <label for="newPassword" class="col-fixed label" style="width:150px">New Password:</label>
                    <div class="col">
                        <!-- <input pPassword id="newPassword" type="password" [feedback]="false"  [(ngModel)]="login.newPassword" class="text-base text-color surface-overlay p-1 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"> -->
                        <input pPassword id="newPassword" type="password" [feedback]="false"  [(ngModel)]="login.newPassword">
                    </div>
                </div>      
                
                <div class="field grid">
                    <label for="confirmPassword" class="col-fixed label" style="width:150px">Confirm Password:</label>
                    <div class="col">
                        <!-- <input pPassword id="confirmPassword" type="password" [feedback]="false"  [(ngModel)]="login.confirmPassword" class="text-base text-color surface-overlay p-1 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"> -->
                        <input pPassword id="confirmPassword" type="password" [feedback]="false"  [(ngModel)]="login.confirmPassword">
                    </div>
                </div>      
            }
            
        </div>
    
        <p-footer>

            <table class="table table-dark">
                <tbody>
                    <tr>
                        <td>
                            <p-button label="Submit" icon="pi pi-check" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSubmitClick()"></p-button>
                        </td>
                    </tr>
                </tbody>
            </table>      
            @if(error) {
                <div class="alert alert-danger">
                    <p-message severity="error">{{error}}</p-message>
                </div>
            }
                      

        </p-footer>


        <div class="d-flex justify-content-center">
            <div class="mx-2">
                <a href="javascript:void(0)" (click)="onForgotPassword()">Forgot username/password</a>
            </div>
        </div>


    </p-card>


</div>

</div>



